import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import GenericModel from 'js/models/generic.model';

    export default GenericModel.extend({
        idAttribute: 'contentId',
        defaults: {
            filename: null,
            filePath: null,
            fileType: null,
            fileSubType: null,
            author: null,
            created: null,
            createdBy: null,
            lastModified: null,
            lastModifiedBy: null,
            mimeType: null,
            data: null,
            fileLength: null,
            file: null
        },
        parse: function (data) {
            if (!data.fileType) {
                data.fileType = data.mimeType.split("/")[0];
            }
            if (!data.fileSubType) {
                data.fileSubType = data.mimeType.split("/")[1];
            }

            return data;
        }
    });
